const MAX_DELIVERY_ENTRIES = 512
const DELIVERY_TTL_MS = 30 * 60 * 1000

const deliveries = new Map<string, number>()

const pruneDeliveries = (now: number) => {
  for (const [key, createdAt] of Array.from(deliveries.entries())) {
    if (now - createdAt > DELIVERY_TTL_MS) deliveries.delete(key)
  }
  while (deliveries.size >= MAX_DELIVERY_ENTRIES) {
    const oldestKey = deliveries.keys().next().value
    if (typeof oldestKey !== "string") break
    deliveries.delete(oldestKey)
  }
}

export const deliverVisitOnce = async (
  deliveryKey: string,
  deliver: () => Promise<Response>
): Promise<void> => {
  const normalizedKey = deliveryKey.trim()
  if (!normalizedKey) return
  const now = Date.now()
  pruneDeliveries(now)
  if (deliveries.has(normalizedKey)) return
  deliveries.set(normalizedKey, now)

  try {
    const response = await deliver()
    if (response.status >= 500) deliveries.delete(normalizedKey)
  } catch {
    deliveries.delete(normalizedKey)
  }
}
